import type { TOC } from '@ember/component/template-only';
import GeneralEventName from 'lumen/components/general/event-name';
import dayjsFormat from 'lumen/helpers/dayjs-format';
import type { Event, Holiday } from 'lumen/models';
import type { PartialDateFormatType } from 'lumen/utils/constants/general-constants';

import styles from './short-term-rental-event-item.module.css';

interface HotelShortTermRentalShortTermRentalEventItemSignature {
  Args: {
    event: Event | Holiday;
    partialDateFormat: PartialDateFormatType;
  };
}

const HotelShortTermRentalShortTermRentalEventItem = <template>
  <div class="{{styles.event-item}} flex min-w-0 flex-col gap-100">
    <GeneralEventName @event={{@event}} class="text-200--regular" />
    <p class="text-200--regular text-neutral-subdued">
      {{dayjsFormat
        @event.startDate
        format=@partialDateFormat.WEEKDAY_AND_MONTH_AND_DAY_MEDIUM
      }}
      {{#unless @event.isSingleDay}}
        -
        {{dayjsFormat
          @event.endDate
          format=@partialDateFormat.WEEKDAY_AND_MONTH_AND_DAY_MEDIUM
        }}
      {{/unless}}
    </p>
  </div>
</template> satisfies TOC<HotelShortTermRentalShortTermRentalEventItemSignature>;

export default HotelShortTermRentalShortTermRentalEventItem;
